import React from 'react';
import { FileText } from 'lucide-react';
import { cn } from '../utilsFunction/cn';
import { MindSession } from '../types';

interface DashboardHeaderProps {
  session: MindSession;
}

export const DashboardHeader: React.FC<DashboardHeaderProps> = ({ session }) => {
  return (
    <div className="bg-white rounded-xl shadow-soft p-6 mb-8">
      <div className="flex items-center gap-3">
        <div className="p-2 bg-accent-100 rounded-lg">
          <FileText className="w-6 h-6 text-accent-600" />
        </div>
        <div>
          <h1 className="text-2xl font-bold text-primary-900">ABG Event Bench</h1>
        </div>
      </div>
    </div>
  );
};